import InsideSalesListTableModals from './InsideSalesListTableModals';

export default InsideSalesListTableModals;
